import { companySizeList } from "./form-constants";
import { EMAIL_PATTERN } from "constants/input-validations-patterns";
import { inputTypes } from "constants/form-input-types";
import TextInput from "client/components/system/form-inputs/text-input/text-input";
import TextInputFloatingLabel from "client/components/system/form-inputs/text-input/text-input-floating-label";
import TextareaInput from "client/components/system/form-inputs/textarea-input/textarea-input";
import TextareaInputFloatingLabel from "client/components/system/form-inputs/textarea-input/textarea-input-floating-label";
import PhoneInput from "client/components/system/form-inputs/phone-input/phone-input";
import PhoneInputFloatingLabel from "client/components/system/form-inputs/phone-input/phone-input-floating-label";
import SelectInput from "client/components/system/form-inputs/select-input/select-input";
import SelectInputFloatingLabel from "client/components/system/form-inputs/select-input/select-input-floating-label";
import CheckboxInput from "client/components/system/form-inputs/checkbox-input/checkbox-input";
import MultiSelectInput from "client/components/system/form-inputs/multi-select-input/multi-select-input";
import MultiSelectInputFloatingLabel from "client/components/system/form-inputs/multi-select-input/multi-select-input-floating-label";
// Defined in constants/form-input-types.js so isomorphic CJS services can read the same strings
// without importing the input components below.
export { inputTypes };
const inputTypesToComponent = {
    [inputTypes.TEXT]: TextInput,
    [inputTypes.NUMBER]: TextInput,
    [inputTypes.EMAIL]: TextInput,
    [inputTypes.SELECT]: SelectInput,
    [inputTypes.MULTI_SELECT]: MultiSelectInput,
    [inputTypes.TEXT_AREA]: TextareaInput,
    [inputTypes.PHONE]: PhoneInput,
    [inputTypes.CHECKBOX]: CheckboxInput
};
const inputTypesToFloatingLabelComponent = {
    [inputTypes.TEXT]: TextInputFloatingLabel,
    [inputTypes.NUMBER]: TextInputFloatingLabel,
    [inputTypes.EMAIL]: TextInputFloatingLabel,
    [inputTypes.SELECT]: SelectInputFloatingLabel,
    [inputTypes.MULTI_SELECT]: MultiSelectInputFloatingLabel,
    [inputTypes.TEXT_AREA]: TextareaInputFloatingLabel,
    [inputTypes.PHONE]: PhoneInputFloatingLabel,
    [inputTypes.CHECKBOX]: CheckboxInput
};
const MAXIMUM_INPUT_LENGTH = 40;
const MINIMUM_PHONE_LENGTH = 8;
const MAXIMUM_PHONE_LENGTH = 40;
export const MAXIMUM_LONG_INPUT_LENGTH = 120;
export const getInputComponentByType = (type, useFloatingLabel = false)=>{
    if (useFloatingLabel) {
        return inputTypesToFloatingLabelComponent[type] || TextInputFloatingLabel;
    }
    return inputTypesToComponent[type] || TextInput;
};
export const FIRSTNAME_INPUT = {
    id: "first_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.firstName",
    validate: (val)=>val.length < MAXIMUM_INPUT_LENGTH
};
export const LASTNAME_INPUT = {
    id: "last_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.lastName",
    validate: (val)=>val.length < MAXIMUM_INPUT_LENGTH
};
export const EMAIL_INPUT = {
    id: "email",
    type: inputTypes.EMAIL,
    title: "forms.fieldTitle.workEmail",
    placeholder: "name@company.com",
    validate: (val)=>EMAIL_PATTERN.test(val),
    errorMessage: "forms.emailField.errorMessage"
};
export const PHONE_INPUT = {
    id: "phone",
    type: inputTypes.PHONE,
    title: "forms.fieldTitle.phoneNumber",
    validate: (val)=>(val === null || val === void 0 ? void 0 : val.length) >= MINIMUM_PHONE_LENGTH && (val === null || val === void 0 ? void 0 : val.length) < MAXIMUM_PHONE_LENGTH,
    errorMessage: "forms.phoneField.errorMessage"
};
export const COMPANY_SIZE_INPUT = {
    id: "company_size",
    type: inputTypes.SELECT,
    title: "forms.fieldTitle.companySize",
    options: companySizeList,
    defaultValue: "forms.fields.selectPlaceholder"
};
export const CHECKBOX_INPUT = {
    id: "checkbox_input",
    type: inputTypes.CHECKBOX,
    text: "forms.zendesk.tickets.contactConsentCheckbox",
    defaultValue: false
};
